export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const GET_USER_INFOS = 'GET_USER_INFOS';

export const RENEW_USER_API_TOKEN = 'RENEW_USER_API_TOKEN';
